import {useState, useEffect} from 'react'

/**
 * A custom hook that implements local storage with state management
 * @param {string} key - Key to store the value under in localStorage
 * @param {any} initialValue - Initial value to use if no value is found in localStorage
 * @returns {[any, function]} - A tuple with the current value and a setter function
 */
export const useLocalStorage = (key, initialValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    if (typeof globalThis === 'undefined') {
      return initialValue
    }
    try {
      const item = globalThis.localStorage.getItem(key)
      return item ? JSON.parse(item) : initialValue
    } catch (error) {
      console.error('Error reading from localStorage:', error)
      return initialValue
    }
  })

  useEffect(() => {
    if (typeof globalThis !== 'undefined') {
      try {
        globalThis.localStorage.setItem(key, JSON.stringify(storedValue))
      } catch (error) {
        console.error('Error writing to localStorage:', error)
      }
    }
  }, [key, storedValue])

  return [storedValue, setStoredValue]
}
